<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <!-- <div class="ts-app-shell--header">
        <h5>
          <strong>Apprentice</strong>
        </h5>
      </div> -->
      <el-row container :gutter="24" class="bg-welcome">
        <el-col :xs="24" :md="14" :lg="14">
          <br />
          <br />
          <h5 style="padding-left: 10px">
            <strong>Welcome to</strong>
          </h5>
          <img
            src="~../../../assets/img/the-logo-welcome.png"
            style="height: 50px"
          />
          <br />
          <br />
          <p style="color: black; font-size: 18px">
            Welcome to the Apprenticeship matching platform. If you are looking
            to be matched to new apprenticeship opportunities based on your
            skills, wanting to identify your hidden talents and take control of
            your career… <br /><br />
            …You are in the right place. We have compiled information and
            resources along with providing you a unique opportunity to change
            how people connect with job opportunities.
          </p>
        </el-col>
        <el-col :xs="24" :md="10" :lg="10" style="text-align: center">
          <img src="~../../../assets/img/welcome-welcome.svg" />
        </el-col>
      </el-row>
    </div>
    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <el-row style="text-align: center" :gutter="10">
          <el-col class="tile_align">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="updateMySGA">
                <h6 class="card-font">
                  Complete My <br />
                  Skills Profile
                </h6>
                <div class="dash-card">
                  <i class="far fa-address-card"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >My Task</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col class="tile_align">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="viewManageUserInterests">
                <h6 class="card-font">
                  Manage My <br />
                  Area of Interest
                </h6>
                <div class="dash-card">
                  <i class="fas fa-biking"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >My Task</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col class="tile_align">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="viewApprenticeshipMatches">
                <h6 class="card-font">
                  Apprenticeship <br />
                  Role Matches
                </h6>
                <div class="dash-card">
                  <i class="fas fa-address-card"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col class="tile_align">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="goToUserProfileSettings">
                <h6 class="card-font">
                  Public Profile/<br />
                  Resume
                </h6>
                <div class="dash-card">
                  <i class="fas fa-user-cog"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col class="tile_align">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="goToMySkillsPassport">
                <h6 class="card-font">
                  Skills<br />
                  Passport
                </h6>
                <div class="dash-card">
                  <i class="fas fa-passport"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >Manage</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog
      id="incomplete"
      title=""
      :visible.sync="showIncompleteProfileModal"
      width="800px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="onCloseModal(null)"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <h5>Welcome to TalentSensus!</h5>
      <br />
      <h6 style="word-break: break-word">
        To get started, you need to complete 'My Skills Profile' before you can
        apply for roles. Next, we would like you to explore the other core
        feature we offer.
      </h6>
      <br />
      <br />
      <el-row style="display:block">
        <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
          <div style="margin-bottom: 10px; width: 180px; margin: auto">
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" style="width: 300px; word-wrap: break-word;">
                {{
                  completeProfileCriteria.sgaCompleted == true
                    ? "You have completed your skills profile"
                    : "You have not completed your skills profile yet!"
                }}
              </div>
              <el-card
                shadow="hover"
                v-bind:style="
                  completeProfileCriteria.sgaCompleted == true
                    ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                    : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                "
                style="text-align: center !important; margin: auto;"
              >
                <div class="card-body" @click="updateMySGA">
                  <h6 class="card-font">
                    Complete My <br />
                    Skills Profile
                  </h6>
                  <div class="dash-card">
                    <i
                      class="far fa-address-card"
                      aria-hidden="true"
                      style="font-size: 50px; padding: 10px;"
                    ></i>
                  </div>
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button
                        class="ts-btn-small card-button"
                        style="width: 100%; background-color: #00C8DC; color: white; pointer-events: none;"
                        >My Task
                      </el-button>
                    </span>
                  </div>
                </div>
              </el-card>
            </el-tooltip>
            <v-icon
              style="width:12;height:12"
              class="check_indicator"
              v-if="completeProfileCriteria.sgaCompleted == true"
              name="check-circle"
            />
          </div>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
          <br />
          <h6 class="card-font">Complete your details</h6>
          <p>
            Here you will be able to enter your personal details from education, 
            work history, certifications, and the company culture you desire to 
            work with. 
          </p>
        </el-col> </el-row
      ><br />
      <el-row style="display:block">
        <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
          <div style="margin-bottom: 10px; width: 180px; margin: auto">
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" style="width: 300px; word-wrap: break-word;">
                {{
                  completeProfileCriteria.numberOfVacantMatchDone >=
                  doneCriteria
                    ? "You have reached role matching criteria"
                    : "You have " +
                      completeProfileCriteria.numberOfVacantMatchDone +
                      "/" +
                      doneCriteria +
                      " role matching done."
                }}
              </div>
              <el-card
                shadow="hover"
                v-bind:style="
                  completeProfileCriteria.numberOfVacantMatchDone >=
                  doneCriteria
                    ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                    : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                "
                style="text-align: center !important; margin: auto;"
              >
                <div class="card-body" @click="viewApprenticeshipMatches">
                  <h6 class="card-font">
                    Vacant Role <br />
                    Matches
                  </h6>
                  <div class="dash-card">
                    <i
                      class="fas fa-user-tie"
                      aria-hidden="true"
                      style="font-size: 50px; padding: 10px;"
                    ></i>
                  </div>
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button
                        class="ts-btn-small card-button"
                        style="width: 100%; background-color: #00C8DC; color: white; pointer-events: none;"
                        >View
                      </el-button>
                    </span>
                  </div>
                </div>
              </el-card>
            </el-tooltip>
            <v-icon
              style="width:12;height:12"
              class="check_indicator"
              v-if="
                completeProfileCriteria.numberOfVacantMatchDone >= doneCriteria
              "
              name="check-circle"
            />
          </div>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
          <br />
          <h6 class="card-font">Check your role matching</h6>
          <p>
            Here you can see jobs that talentsensus have matched to your
            profile. Visit this page to find out how to apply.
          </p>
        </el-col> </el-row
      ><br />
      <div class="el-dialog__footer" style="padding: 50px;">
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          style="margin: auto; width: 300px"
          @click="onCloseModal(null)"
        >
          Continue
        </button>
      </div>
    </el-dialog>
    <el-dialog
      id="completed"
      title=""
      :visible.sync="showCompleteProfileModal"
      width="800px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="onCloseCompleteProfileModal(null)"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <h5>Congratulations!</h5>
      <br />
      <h5>
        You have successfully managed and explored core features of
        talentsensus.
      </h5>
      <br />
      <div>
        <br />
        <el-row style="display:block">
          <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
            <div style="margin-bottom: 10px; width: 180px; margin: auto">
              <el-tooltip class="item" effect="dark" placement="right">
                <div
                  slot="content"
                  style="width: 300px; word-wrap: break-word;"
                >
                  {{
                    completeProfileCriteria.sgaCompleted == true
                      ? "You have completed your skills profile"
                      : "You have not completed your skills profile yet!"
                  }}
                </div>
                <el-card
                  shadow="hover"
                  v-bind:style="
                    completeProfileCriteria.sgaCompleted == true
                      ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                      : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                  "
                  style="text-align: center !important; margin: auto;"
                >
                  <div class="card-body" @click="updateMySGA">
                    <h6 class="card-font">
                      Complete My <br />
                      Skills Profile
                    </h6>
                    <div class="dash-card">
                      <i
                        class="far fa-address-card"
                        aria-hidden="true"
                        style="font-size: 50px; padding: 10px;"
                      ></i>
                    </div>
                    <div class="bottom clearfix">
                      <span slot="footer" class="ts-modal--footer">
                        <el-button
                          class="ts-btn-small card-button"
                          style="width: 100%; background-color: #00C8DC; color: white; pointer-events: none;"
                          >My Task
                        </el-button>
                      </span>
                    </div>
                  </div>
                </el-card>
              </el-tooltip>
              <v-icon
                style="width:12;height:12"
                class="check_indicator"
                v-if="completeProfileCriteria.sgaCompleted == true"
                name="check-circle"
              />
            </div>
          </el-col>
          <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
            <!-- <br/>
            <h6 class="card-font">Complete your details </h6>
            <p>
              Here you were able to enter your personal details from education, work history, certifications, up to company culture you desired to work with.
            </p> -->
          </el-col> </el-row
        ><br />
        <el-row style="display:block">
          <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
            <div style="margin-bottom: 10px; width: 180px; margin: auto">
              <el-tooltip class="item" effect="dark" placement="right">
                <div
                  slot="content"
                  style="width: 300px; word-wrap: break-word;"
                >
                  {{
                    completeProfileCriteria.numberOfVacantMatchDone >=
                    doneCriteria
                      ? "You have reached role matching criteria"
                      : "You have " +
                        completeProfileCriteria.numberOfVacantMatchDone +
                        "/" +
                        doneCriteria +
                        " role matching done."
                  }}
                </div>
                <el-card
                  shadow="hover"
                  v-bind:style="
                    completeProfileCriteria.numberOfVacantMatchDone >=
                    doneCriteria
                      ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                      : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                  "
                  style="text-align: center !important; margin: auto;"
                >
                  <div class="card-body" @click="viewApprenticeshipMatches">
                    <h6 class="card-font">
                      Vacant Role <br />
                      Matches
                    </h6>
                    <div class="dash-card">
                      <i
                        class="fas fa-user-tie"
                        aria-hidden="true"
                        style="font-size: 50px; padding: 10px;"
                      ></i>
                    </div>
                    <div class="bottom clearfix">
                      <span slot="footer" class="ts-modal--footer">
                        <el-button
                          class="ts-btn-small card-button"
                          style="width: 100%; background-color: #00C8DC; color: white; pointer-events: none;"
                          >View
                        </el-button>
                      </span>
                    </div>
                  </div>
                </el-card>
              </el-tooltip>
              <v-icon
                style="width:12;height:12"
                class="check_indicator"
                v-if="
                  completeProfileCriteria.numberOfVacantMatchDone >=
                    doneCriteria
                "
                name="check-circle"
              />
            </div>
          </el-col>
          <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
            <!-- <br/>
            <h6 class="card-font">Check your role matching</h6>
            <p>
              Here you can see jobs where talentsensus have matched to your profile. Make sure to always visit this page and be ready to apply.
            </p> -->
          </el-col> </el-row
        ><br />
      </div>
      <div class="el-dialog__footer" style="padding: 50px; text-align: center">
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          style="margin: auto; width: 300px"
          @click="ConfirmCompleteProfile(null)"
        >
          Thanks! don't show this anymore
        </button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="showEducationModal"
      :close-on-click-modal="false"
      :show-close="false"
      width="420px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="closeEducationModal(null)"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>

      <h6 style="word-break:normal;">
        Your education details need some attention!
      </h6>
      <br />
      <span style="font-size: 14px;word-break:normal;"
        >Please update your education listed below as their graduation dates
        have passed. Move the graduation date to a later date, remove the
        education, or make the education completed by removing the graduation
        date.</span
      ><br />
      <div class="education-details">
        <el-table
          :data="educationDetails.courseDetails"
          stripe
          style="width: 100%;"
          height="400"
        >
          <el-table-column label="Title" width="180">
            <template slot-scope="scope">
              <span style="word-break:normal;">{{
                scope.row.courseTitle | moment("MMMM DD, YYYY")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Graduation Date" width="160">
            <template slot-scope="scope">
              <span>{{
                scope.row.graduationDate | moment("MMMM DD, YYYY")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div v-for="(detail, index) in educationDetails.CourseDetails" :key="index">
          <span> {{ detail.CourseTitle }} - {{ detail.GraduationDate | moment("MMMM DD, YYYY") }}</span> <br/>
        </div> -->
      </div>

      <div
        class="el-dialog__footer"
        style="padding-left: 80px;padding-top: 30px;text-align: center"
      >
        <el-button
          @click="updateEducationDetail"
          style="width:180px"
          class="ts-btn ts-btn-small ts-btn-secondary"
          >Update Education Details</el-button
        >
      </div>
    </el-dialog>
    <TSLoading :active="isLoading" :defaultMessage="'Please wait...'" :altMessage="'Please hold on for a moment while we process the data...'"/>
  </div>
</template>
<script>
import TSLoading from '../../../components/TSLoading.vue';

export default {
  components: {
    TSLoading
  },
  created() {
    if (sessionStorage.getItem("fromSuperAdmin") != null) {
      this.$store.dispatch("account/restore").then(() => {});
    }

    this.$store.dispatch("apprentice/getuserinterestcriteria").then(res => {
      this.userinterestcriteria = res;
    });

    // this.completeProfileCriteria.sgaCompleted = true;
    this.completeProfileCriteria.numberOfVacantMatchDone = 10;
    this.isLoading = true;
    this.$store.dispatch("account/getuserfamiliarity").then(res => {
      var process_baseline = process.env.VUE_APP_PROCESS_DONE_BASELINE;
      this.completeProfileCriteria = res;
      if (
        res.sgaCompleted == true &&
        res.numberOfVacantMatchDone >= parseInt(process_baseline) &&
        res.confirmed == false
      ) {
        this.showCompleteProfileModal = true;
        this.showIncompleteProfileModal = false;
      } else if (res.confirmed == false) {
        this.showCompleteProfileModal = false;
        this.showIncompleteProfileModal = true;
      }
    })
    .finally(() => {
      this.isLoading = false;
    });

    //TODO: uncomment checkEducationDetails
    // // Check users education details
    // this.$store.dispatch("apprentice/checkEducationDetails")
    //   .then((res) => {
    //     this.educationDetails = res;
    //     this.showEducationModal = !this.educationDetails.IsValid;
    // });
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    },
    doneCriteria() {
      return parseInt(process.env.VUE_APP_PROCESS_DONE_BASELINE);
    }
  },
  data() {
    return {
      showIncompleteProfileModal: false,
      showCompleteProfileModal: false,
      completeProfileCriteria: {},
      userinterestcriteria: [],
      educationDetails: {},
      showEducationModal: false,
      isLoading: false,
    };
  },
  methods: {
    updateMySGA() {
      this.$router.push({ name: "sgaIntro" });
    },
    viewManageUserInterests() {
      this.$store.dispatch("apprentice/isprofilecreated").then(res => {
        if (!res) {
          //check if profile is not completed cannot add user interest
          this.$confirm(
            `Apprenticeship profile not yet completed. Please complete your apprenticeship profile before adding area of interest`,
            "Warning",
            {
              confirmButtonText: "OK",
              dangerouslyUseHTMLString: true,
              type: "warning",
              center: true
            }
          ).then(() => {
            return false;
          });
        } else {
          this.$router.push({ name: "UserInterestsLanding" });
        }
      });
    },
    viewApprenticeshipMatches() {
      if (
        this.completeProfileCriteria.sgaCompleted != true &&
        this.userinterestcriteria.length == 0
      ) {
        this.$confirm(
          `You must complete your Skills Profile and Area of Interest first!`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {
          return false;
        });
      } else if (
        this.completeProfileCriteria.sgaCompleted != true &&
        this.userinterestcriteria.length > 0
      ) {
        this.$confirm(
          `You must complete your Skills Profile first!`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {
          return false;
        });
      } else if (
        this.completeProfileCriteria.sgaCompleted == true &&
        this.userinterestcriteria.length == 0
      ) {
        this.$confirm(
          `You must complete your Area of Interest first!`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {
          return false;
        });
      } else this.$router.push({ name: "role-matching-apprentice" });
    },
    goToUserProfileSettings() {
      if (this.completeProfileCriteria.sgaCompleted != true) {
        this.$confirm(
          `You must complete your Skills Profile first!`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {});
      } else this.$router.push({ name: "ApprenticeProfilePageSetting" });
    },
    goToMySkillsPassport() {
      this.$router.push({ name: "ApprenticeSkillsPassport" });
    },
    onCloseModal() {
      this.showIncompleteProfileModal = false;
    },
    onCloseCompleteProfileModal() {
      this.showCompleteProfileModal = false;
    },
    ConfirmCompleteProfile() {
      this.$store.dispatch("account/confirmcompleteprofile").then(res => {
        this.onCloseCompleteProfileModal();
      });
    },
    closeEducationModal() {
      this.showEducationModal = false;
    },
    updateEducationDetail() {
      this.$router.push({ name: "sgaEducation" });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/project/dashboard.scss";

.tile_align {
  width: 200px !important;
  margin: 10px 10px;
}

#completed .el-dialog__body {
  background-image: url("~../../../assets/img/Congratulations.gif");
  background-size: contain;
  padding: 30px 20px 30px 20px;
  position: unset;
  border: none;
  background-repeat: no-repeat;
}

.check_indicator {
  color: #31a537;
  width: 50px !important;
  height: 50px !important;
  float: right;
  margin-top: -40px;
  margin-right: -30px;
}
</style>
